import axios from 'axios';
import { storage, STORAGE_KEYS } from '@utils/storage';
import type { AuthTokens } from '@/types';

const API_BASE = import.meta.env.VITE_API_URL || '/api';

export const storageService = {
  async uploadImage(file: File): Promise<string> {
    const formData = new FormData();
    formData.append('file', file);
    const tokens = storage.get<AuthTokens>(STORAGE_KEYS.AUTH_TOKENS);
    const res = await axios.post(`${API_BASE}/storage/upload`, formData, {
      headers: tokens?.access_token
        ? { Authorization: `Bearer ${tokens.access_token}` }
        : undefined,
    });
    return res.data.data.url as string;
  },
};
